export enum ImpactCrusherCITypes {
  CI711 = 'CI711',
  CI712 = 'CI712',
  CI721 = 'CI721',
  CI722 = 'CI722',
  CI731 = 'CI731',
  CI732 = 'CI732',
}
